
































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ModulesHelper from '@core/services/modules.helper';

@Component({
  name: 'bpc-booking-event-confirm-modal',
  components: {},
})
export default class BookingEventConfirmModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly ownToRepetitiveBooking: boolean;
  @Prop({ type: Array, default: [] }) readonly eventIds: string[] | number[];

  confirmingEvents: boolean = false;
  repetitiveActionOptionSelected: string = 'only_this';
  repetitiveActionOptions: Record<string, any> = [
    {
      text: this.$t('global.modals.update-booking-event.multiple.action_option.options.only'),
      value: 'only_this',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.next_same_events',
      ),
      value: 'next_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.all_same_events',
      ),
      value: 'all_same',
    },
    {
      text: this.$t(
        'global.modals.update-booking-event.multiple.action_option.options.confirm_all_events',
      ),
      value: 'confirm_all',
    },
  ];

  notificationActionOptionSelected: boolean = true;
  notificationActionOptions: Record<string, any> = [
    {
      text: this.$t('global.no'),
      value: false,
    },
    {
      text: this.$t('global.yes'),
      value: true,
    },
  ];

  replaceActionOptionSelected: boolean = true;
  replaceActionOptions: Record<string, any> = [
    {
      text: this.$t('global.no'),
      value: false,
    },
    {
      text: this.$t('global.yes'),
      value: true,
    },
  ];

  get totalItemsToConfirm(): number {
    return this.eventIds.length;
  }

  get modalTitle(): string {
    if (this.totalItemsToConfirm > 1) {
      return this.$t('global.modals.multiple_booking_event_confirm.title').toString();
    } else {
      return this.$t('global.modals.single_booking_event_confirm.title').toString();
    }
  }

  get modalBody(): string {
    if (this.eventIds.length > 1) {
      return this.$t('global.modals.multiple_booking_event_confirm.body').toString();
    } else {
      return this.$t('global.modals.single_booking_event_confirm.body').toString();
    }
  }

  get showNotifyOption(): boolean {
    return (
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME) &&
      this.$store.getters['centerSettings/centerSettings']?.send_booking_confirmation_email
    );
  }

  get modalBodyNotification(): string {
    return this.$t('bookings.booking_events.notify_by_email.label').toString();
  }

  get modalBodyReplace(): string {
    return this.$t('global.modals.replace_in_case_of_conflicts.label').toString();
  }

  get modalBodyRepetitive(): string {
    return this.$t('global.modals.update-booking-event.multiple.action_option.label').toString();
  }

  onCloseModal(): void {
    this.$emit('close');
    this.confirmingEvents = false;
    this.repetitiveActionOptionSelected = 'only_this';
  }

  onConfirmSingle(): void {
    this.confirmingEvents = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('booking-event');
    const eventId = this.eventIds[0];
    const path = `${basePath}/confirm/${eventId}`;
    this.$bpcApi
      .put(path, {
        id: eventId,
        repetitiveAction: this.repetitiveActionOptionSelected,
        notifyByEmail: this.notificationActionOptionSelected,
        replaceInCaseOfConflicts: this.replaceActionOptionSelected,
      })
      .subscribe(
        () => {
          this.$emit('confirmed');
          this.$bpcMessage.showSuccessMessage({
            text: 'global.booking_event.success_single_confirm',
          });
          this.onCloseModal();
        },
        () => {
          this.onCloseModal();
        },
      );
  }

  onConfirmMultiple(): void {
    console.log('Multiple confirm');
  }
}
